import {loadFormInstanceData} from './formPersistence'
import cloneDeep from 'lodash/cloneDeep';
import {databaseViewApi} from './redux/databaseView';

export function resolveVariable(value,data)
	{
	console.log(value,data);
	if (typeof value!="string")
		return value;

	var match=value.match(/^\{([^}]+)\}$/);

	if (!match)
		return value;

	return data?.[match[1]];
	}
	
export async function loadForm(dispatch, formID,variables,visited=new Set())
	{	
	
	if (visited.has(formID))
		{
		console.warn("Form already included",formID);
		return null;
		}

	visited.add(formID);

	var PromiseArray=[];
	var schemaData=await dispatch(databaseViewApi.endpoints.retrieve.initiate({category:"form",name:formID}));
	async function loadSubform(component)
		{
		var formName=resolveVariable(component.properties?.name,variables);
		if (formName)
			{
			var subform=await loadForm(dispatch,formName,variables,visited);
			if (subform)
				component.components=subform.components;			
			else 
				component.components=[];
			}
		}
	if (!schemaData.data.success)
		{
		console.log("form load failed");
		return;
		}
	schemaData=schemaData.data.data[0].components;	
	schemaData=JSON.parse(schemaData);
//	console.log("formbj",formID,schemaData);
	schemaData.components.forEach((component)=>
		{
		if (component?.properties?.type==="nestedForm")
			{
			PromiseArray.push(loadSubform(component));
			}
		});
	await Promise.all(PromiseArray);
//	visited.delete(formID);
	return schemaData;
	}
	
export async function initialiseFormData(dispatch,instanceID,stateID,dataVersion)
	{
	var formData=cloneDeep(await loadFormInstanceData(dispatch,instanceID,stateID));

	if (formData==null)
		formData={};

	if (dataVersion!==undefined)
		{
		var oldData=await dispatch(
			databaseViewApi.endpoints.loadInstanceStateData.initiate({id:dataVersion})
			);

		if (oldData.isSuccess&&oldData.data.success)
			{
			formData={
				...formData,
				...cloneDeep(oldData.data.data.data)
				};
			}

		formData.readOnly=true;
		}
	else
		formData.readOnly=false;

	return formData;
	}
